import { Heart } from "lucide-react";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <a className={`brand ${compact ? "brand--compact" : ""}`} href="/#top">
      <span className="brand__mark" aria-hidden="true">
        <Heart size={17} strokeWidth={2.3} />
      </span>
      <span>Markéta</span>
      <span className="brand__amp">&</span>
      <span>Tomáš</span>
    </a>
  );
}
